import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { dishes } from "../data/dishes";
import { articles, pairingCategories } from "../data/articles";
import { useTheme, useDocumentTitle } from "../hooks/useSite";
import FoodImage from "../components/FoodImage";
import ArticleCard from "../components/ArticleCard";

export default function PairingsPage() {
  useTheme(dishes[0]);
  useDocumentTitle("Pairings");
  const [category, setCategory] = useState("All");
  const [query, setQuery] = useState("");
  const featured = articles[0];

  const results = useMemo(() => {
    const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
    return articles.filter(
      (a) =>
        (category === "All" || a.category === category) &&
        terms.every((t) => `${a.title} ${a.desc} ${a.category}`.toLowerCase().includes(t))
    );
  }, [category, query]);

  const reset = () => {
    setCategory("All");
    setQuery("");
    const el = document.getElementById("ro-pairing-search");
    if (el) el.focus();
  };

  return (
    <>
      <section className="ro-pairing-intro">
        <div className="ro-container ro-split">
          <div>
            <h1>
              <strong className="ro-italic">RollOver</strong>
              <br />
              <span className="ro-outline">Pairings</span>
            </h1>
            <p>Find a little inspiration for your next café break. Savoury bites, sweet moments and a few good things to enjoy together.</p>
          </div>
          <FoodImage dish={dishes[6]} className="ro-education-intro__food" animate />
        </div>
      </section>
      <section className="ro-section">
        <div className="ro-container">
          <Link className="ro-featured" to={`/pairings/${featured.id}`}>
            <img src={featured.image} alt={featured.imageAlt} />
            <div>
              <span className="ro-small">FEATURED CAFÉ MOMENT</span>
              <h2>{featured.title}</h2>
              <p>{featured.desc}</p>
              <span className="ro-small ro-featured__more">Explore this idea →</span>
            </div>
          </Link>
          <div className="ro-filter">
            <div>
              <span className="ro-filter__label" id="ro-filter-label">
                Show:
              </span>
              <div className="ro-filter__options" role="group" aria-labelledby="ro-filter-label">
                {pairingCategories.map((c) => (
                  <button key={c} type="button" aria-pressed={c === category} onClick={() => setCategory(c)}>
                    {c}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <label className="ro-filter__label" htmlFor="ro-pairing-search">
                Search:
              </label>
              <input id="ro-pairing-search" type="search" placeholder="What are you looking for?" value={query} onChange={(e) => setQuery(e.target.value)} autoComplete="off" />
            </div>
          </div>
          <p className="ro-small ro-filter__count" role="status" aria-live="polite">
            {results.length} pairing {results.length === 1 ? "idea" : "ideas"}
          </p>
          <div className="ro-article-grid">
            {results.length ? (
              results.map((a) => <ArticleCard key={a.id} article={a} compact />)
            ) : (
              <div className="ro-no-results">
                <h2>No moments found.</h2>
                <p>Try another word or explore all our ideas.</p>
                <button type="button" className="ro-pill ro-pill--solid" onClick={reset}>
                  Show all pairings
                </button>
              </div>
            )}
          </div>
          <p className="ro-micro" style={{ marginTop: 40 }}>
            Editorial suggestions only. These are not fixed-price combos, promotions or confirmed current menu offers.
          </p>
        </div>
      </section>
    </>
  );
}
